import React, {useEffect, useState} from 'react'
import { UserAuth } from '../context/AuthContext';


const Dashboard = () => {
  const { user } = UserAuth();

  return (

    <div className="flex flex-col items-center justify-center h-screen dark:bg-gray-900">
      <h1 class="mb-4 text-3xl font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-6xl"><span class="text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">Finding Project</span> Made Easy.</h1>
      {user ? <h1 className="text-2xl font-boldmb-8 text-gray-500 dark:text-gray-400 md:text-xl">Welcome {user.displayName}</h1> : <p class="mb-8 text-lg text-gray-500 dark:text-gray-400 md:text-xl">We have a lot of projects for you to choose from. Just sign up and start finding your project.</p>}
      
      <div class="flex flex-row gap-4 items-center justify-center">
      {user ? <a href="/projects" class="px-6 py-3 text-lg font-medium text-white bg-sky-600 rounded-md hover:bg-sky-700">Projects</a> : <a href="/signin" class="px-6 py-3 text-lg font-medium text-gray-900 bg-gray-100 rounded-md hover:bg-gray-200">Sign In</a>}
      <a href="/signup" class="px-6 py-3 text-lg font-medium text-gray-100 bg-sky-600 rounded-md hover:bg-sky-700">Create New Account</a>
      
      </div>
      
    </div>
    
  )
}

export default Dashboard